import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-5717').catch(console.error);
